import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
  orderBy,
} from "firebase/firestore";
import { db } from "./index";

// A11 (D2) : un autre joueur ne se lit plus que par son profil PUBLIC
// (profiles/{uid}) ; players/{uid} est réservé à son propriétaire.
export const fetchPlayerInfo = async (playerId) => {
  const docSnap = await getDoc(doc(db, "profiles", playerId));
  if (!docSnap.exists()) return null;
  const data = docSnap.data();
  return {
    username: data.username,
    avatarId: data.avatarId,
    // Pour le don d'âme au propriétaire (cf. scan/ecritures.js) : la règle
    // exige que l'entrée existe déjà chez lui.
    animalIds: Array.isArray(data.animalIds) ? data.animalIds.map(String) : [],
  };
};

export const updatePlayer = (playerId, payload) => {
  const docRef = doc(db, "players", playerId);
  return updateDoc(docRef, payload);
};

export const fetchScannedTokens = async (fieldFilters = {}, order = {}) => {
  const { uid, aid, tid } = fieldFilters;
  const { date } = order;
  let scansQuery = query(collection(db, "scans"));
  if (uid) {
    scansQuery = query(scansQuery, where("uid", "==", uid));
  }
  if (tid) {
    scansQuery = query(scansQuery, where("tid", "==", tid));
  }
  if (aid) {
    scansQuery = query(scansQuery, where("aid", "==", aid));
  }
  if (date) {
    scansQuery = query(scansQuery, orderBy("date", date));
  }
  return await getDocs(scansQuery);
};
